/*
  Figma "Stat cell": a figure on the inset surface. Label in Caps/Label, value in
  Title 2, an optional line under it.
*/
const StatCell = ({ label, value, meta, title, className = "" }) => (
  <div title={title} className={`flex min-w-0 flex-col gap-space-4 rounded-[22px] bg-bg-inset p-space-16 ${className}`}>
    <p className="text-caps-label uppercase text-label-secondary">{label}</p>
    <p className="break-words text-title-2 text-label-primary">{value}</p>
    {meta && <p className="text-footnote text-label-secondary">{meta}</p>}
  </div>
);

export default StatCell;
